const styles = {
    mobileScreen: {
        p: 3,
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '48px',
        color: '#3876AA',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
        color: '#3876AA',
    },
    logo: {
        marginBottom: '56px',
    },
    description: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#27344E',
        marginTop: '16px',
    },
};
export default styles;
